export default class FileUploadMiddleware {

  constructor(opts) {

    opts.attrKeys = opts.attrKeys.map((key) => {
      if (!('key' in key)) {
        key = {
          key,
          fieldName: key
        }
      }
      return key
    })

    this.opts = opts
  }

  parseRequestForFileUpload(origData) {

    const file = []
    const data = {}

    Object.keys(origData)
      .forEach((attr) => {

        const match = this.opts.attrKeys
          .find((key) => key.key === attr)

        if (match) {
          data[attr] = []

          file.push(...(origData[match.key] || [])
            .map((f) => {
              data[attr].push({
                ...f,
                // remove actual file obj
                file: undefined,
                // remove data url param
                dataURL: undefined
              })
              return f
            })
            .filter((f) => f.file instanceof File)
            .map((f) => {
              f.file.fieldName = `${match.fieldName}[]`
              return f.file
            }))
        }
        else {
          data[attr] = origData[attr]
        }

      })

    if (data.filePreview) {
      delete data.filePreview
    }

    return {
      data,
      file
    }

  }

  request(opts) {

    if (opts.method === 'post' || opts.method === 'put') {

      const {
        data,
        file
      } = this.parseRequestForFileUpload(opts.data)

      opts = {
        ...opts,
        data,
        file,
        contentType: (file && file.length) ? 'form-data' : (opts.contentType || null)
      }

    }

    return opts

  }
}



// WEBPACK FOOTER //
// ./src/shared/api/middleware/file-upload.js